import { navigate } from "vike/client/router"
import React from "react"
import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"
import Image from "aldoo-ra/Image"
import TextBundle from "aldoo-ra/CMS/text-bundle"

function NotFoundPage() {
  const texts = TextBundle({ id: "transfer_common" })

  return (
    <div className="relative min-h-screen bg-paper">
      <div className="relative flex flex-col w-full min-h-screen items-center justify-center gap-[50px] px-4">
        {/* 404 image */}
        <div className="w-full sm:max-w-[580px] sm:h-[326px]">
          <Image
            id="page_not_found"
            className="max-w-full h-auto"
          />
        </div>

        <Typography 
          component="h1" 
          variant="h4"
            className="text-center"
        >
          {texts?.pageNotFound}
        </Typography>

        <Button 
          variant="admin_primary" 
          onClick={() => navigate("/")}
        >
          {texts?.backToHomeBtn}
        </Button>
      </div>
    </div>
  )
}

export default NotFoundPage